import {ChannelIcon,ChannelIconPicker} from './ChannelIcon';
import { RaidCleanup } from './RaidCleanup';
import {ServerOwnership} from './ServerOwnership';
import {Webhooks} from './Webhooks';

import {DiscoverySettings} from './Discovery';
import {EmoteManager} from './CustomEmotes';
import {MemberControls} from './MemberControls';
import {RoleName} from './RoleName';
import './server-controls.css';
import {ChannelTemplates} from './ChannelTemplates';
import {CommunityInvites,CommunityAudit} from './CommunityManagement';
import {ChannelRolePermissions,RoleOverrides} from './ChannelRolePermissions';
import {RoleIcon} from './RoleIcon';
import {InviteLinkGuard} from './InviteLinkGuard';
import {VanityInvite} from './VanityInvite';

import {ServerRoleManager} from './ServerRoleManager';
import {ServerApps} from './ServerApps';
import {SoundboardSettings} from './Soundboard';
import React, { useEffect, useRef, useState } from 'react';
import {avatarSrc as defaultAvatarSrc} from './avatar';
import {
  Bot,
  Settings,
  Hash,
  Users,
  Link,
  LogOut,
  Trash2,
  Copy,
  Plus,

  Shield,
  Ban,
  UserX,
  Check,
  Lock,

  Sparkles,
  Volume2,
  Eye,Globe,Home,ScrollText,Pencil,Tag,X,ChevronDown
} from 'lucide-react';
import { copyToClipboard, useLang } from './i18n';
import { ImageCropModal } from './ImageCropModal';
import { CustomSelect } from './CustomSelect';
import {Flame,Star,Sword,Gem} from 'lucide-react';
const GUILD_ICONS:Record<string,React.ComponentType<{size?:number}>>={spark:Sparkles,flame:Flame,shield:Shield,star:Star,sword:Sword,gem:Gem};
const GUILD_COLORS=['#ef5252','#f97316','#eab308','#22c55e','#14b8a6','#3b82f6','#6366f1','#a855f7','#ec4899','#94a3b8'];





export function ServerSettings({
  initialAction,onClose,focus,
  community,
  members,
  me,
  request,
  onRefresh,
  onExit,
  onCreateChannel,
  onKick
}: {
  initialAction?: string;
  onClose:()=>void;
  focus?: {page?:string;channelId?:string;category?:string;deleteCategory?:boolean}|null;
  community: any;
  members: any[];
  me: any;
  request: any;
  onRefresh: () => Promise<void>;
  onExit: () => void;
  onCreateChannel: () => void;
  onKick: (p: any) => void;
}) {
  const [lang, , tr] = useLang();
  const isOfficial = community.id === 'malvo-official';
  const owner = community.role === 'owner' || (isOfficial && me?.username?.toLowerCase() === 'malvo');
  const canEditRoles=owner||!!community.capabilities?.manageRoles,canBan=owner||!!community.capabilities?.ban,canInvites=owner||!!community.capabilities?.manageInvites;
  const manage = owner || ['owner', 'moderator'].includes(community.role) || !!community.canManage;

  const [newCategory,setNewCategory]=useState('');
  const categoryNames=[...new Set<string>([...Object.keys(community.categoryPermissions||{}),...community.channels.map((c:any)=>c.category||'')])];
  const canEditChannels=owner||!!community.capabilities?.manageChannels;
  const [memberQuery,setMemberQuery]=useState(''),[banName,setBanName]=useState(''),[banReason,setBanReason]=useState('');
  // Keep the open page when the dialog remounts (refresh, mobile keyboard/rotation) instead of jumping back to the overview.
  const pageKey = 'malvo-server-settings-page:' + community.id;
  const [page, setPageState] = useState<string>(() => { try { return focus?.page || sessionStorage.getItem(pageKey) || 'overview'; } catch { return focus?.page || 'overview'; } });
  const setPage = (next: string) => { setPageState(next); try { sessionStorage.setItem(pageKey, next); } catch {} };
  const [openChannels, setOpenChannels] = useState<string[]>(focus?.channelId ? [focus.channelId] : []);
  const [editingCategory, setEditingCategory] = useState<string | null>(focus?.category || null);
  // Jump straight to the channel or category that was opened from the sidebar.
  useEffect(() => { const id = focus?.channelId ? 'channel-editor-' + focus.channelId : focus?.category ? 'category-editor-' + focus.category : ''; if (id) requestAnimationFrame(() => document.getElementById(id)?.scrollIntoView({ block: 'start' })); }, []);
  const bodyRef = useRef<HTMLElement>(null);
  // Each settings page starts at its top instead of inheriting the previous page's scroll position.
  useEffect(() => { bodyRef.current?.scrollTo({ top: 0 }); }, [page]);
  const [guild,setGuild]=useState({tag:community.guildTag||'',icon:community.guildIcon||'spark',color:community.guildColor||'#ef5252',joinable:community.guildJoin!==0});

  const [name, setName] = useState(community.name);
  const [description, setDescription] = useState(community.description || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [confirm, setConfirm] = useState<any>(focus?.deleteCategory?{kind:'category',category:focus.category}:initialAction ? { kind: initialAction } : null);
  const confirmationName=confirm?.kind==='category'?confirm.category:confirm?.kind==='channel'?confirm.channel.name:community.name;
  const [confirmation, setConfirmation] = useState('');
  const [cropPending, setCropPending] = useState<{ file: File; kind: 'icon' | 'banner' } | null>(null);

  // Roles state
  const [roles, setRoles] = useState<any[]>(community.roles || []);
  const [newRoleName, setNewRoleName] = useState('');
  const [newRoleColor, setNewRoleColor] = useState('#ef5252');
  const [newRolePerms, setNewRolePerms] = useState<string[]>([]);
  const [editingRole, setEditingRole] = useState<any | null>(null);

  // Bans state
  const [bans, setBans] = useState<any[]>([]);



  async function loadRoles() {
    try {
      const r = await request('/communities/' + community.id + '/roles');
      if (Array.isArray(r)) setRoles(r);
    } catch {}
  }

  async function loadBans() {
    try {
      const b = await request('/communities/' + community.id + '/bans');
      if (Array.isArray(b)) setBans(b);
    } catch {}
  }

  useEffect(() => {
    loadRoles();
    if (manage) { loadBans(); }
  }, [community.id]);

  async function run(fn: () => Promise<void>) {
    setError('');
    setSuccess('');
    setBusy(true);
    try {
      await fn();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  function ask(value: any) {
    setConfirm(value);
    setConfirmation('');
    setError('');
  }

  async function uploadServerMedia(file: File, kind: 'icon' | 'banner') {
    await run(async () => {
      const body = new FormData();
      body.append('file', file);
      const upload = await fetch('/api/uploads', {
        method: 'POST',
        headers: { 'x-malvo': '1' },
        signal: AbortSignal.timeout(60000),
        body
      });
      const data = await upload.json();
      if (!upload.ok) throw Error(data.error || 'Upload failed');
      await request('/communities/' + community.id + '/' + kind, 'POST', {
        uploadId: data.id
      });
      await onRefresh();
      setSuccess(
        kind === 'icon'
          ? tr('Server icon updated.', 'Serverbild gespeichert.')
          : tr('Server banner updated.', 'Serverbanner gespeichert.')
      );
    });
  }

  const iconSrc =
    community.id === 'malvo-official' && (!community.icon || community.icon === 'icon.png')
      ? '/icon.png'
      : community.icon === 'icon.png'
      ? '/icon.png'
      : community.icon
      ? '/api/files/' + community.icon
      : null;

  const bannerSrc = community.banner ? '/api/files/' + community.banner : null;
  const inviteUrl = isOfficial ? location.origin + '/malvo' : location.origin + '/i/' + (community.vanityInvite || community.invite);

  function togglePerm(list: string[], setList: (v: string[]) => void, key: string) {
    if (list.includes(key)) setList(list.filter(x => x !== key));
    else setList([...list, key]);
  }

  return (
    <div className={'server-settings server-page-'+page}>
      {cropPending && (
        <ImageCropModal
          file={cropPending.file}
          aspect={cropPending.kind === 'icon' ? 'avatar' : 'banner'}
          onCancel={() => setCropPending(null)}
          onConfirm={croppedFile => {
            const k = cropPending.kind;
            setCropPending(null);
            void uploadServerMedia(croppedFile, k);
          }}
        />
      )}
      <nav>
        <div className="server-settings-brand" style={{backgroundImage:bannerSrc?`linear-gradient(#0005,#0008),url(${bannerSrc})`:undefined}}><h3>{community.name}</h3><button type="button" aria-label={tr('Back to chat','Zurück zum Chat')} onClick={onClose}><Home size={19}/></button><small><Shield size={13}/>{owner?tr('Server owner','Server-Eigentümer'):tr('Server management','Serververwaltung')}</small></div><p className="server-nav-caption">{tr('Server settings','Servereinstellungen')}</p>
        {[
          ['overview', tr('Overview', 'Übersicht'), Settings],
          ['roles', tr('Roles', 'Rollen'), Tag],
          ['channels', tr('Channels', 'Kanäle'), Hash],
          ...(manage?[['templates',tr('Channel templates','Kanalvorlagen'),Copy]]:[]),
          ['members', tr('Members', 'Mitglieder'), Users],
          ...(canBan?[['bans',tr('Bans','Sperren'),Ban]]:[]),
          ['bots', tr('Bots & Integrations', 'Bots & Integrationen'), Bot],
          ...(community.channels.some((c:any)=>c.capabilities?.manage_webhooks)?[['webhooks','Webhooks',Link]]:[]),
          ...(owner?[['discovery','Server finden',Globe]]:[]),...(owner||community.capabilities?.manageEmotes||community.capabilities?.manageServer?[['emotes','Server-Emotes',Sparkles]]:[]),
          ['soundboard', 'Soundboard', Volume2],
          ...(canInvites?[['invite',tr('Invites','Einladungen'),Link],['audit',tr('Audit Log','Audit-Protokoll'),ScrollText]]:[])
        ].map(([key, label, Icon]: any) => (
          <button
            key={key}
            className={page === key ? 'active' : ''}
            onClick={() => {
              setPage(key);
              setConfirm(null);
              setError('');
              setSuccess('');
              if (key === 'roles') loadRoles();
              if (key === 'bans') loadBans();
            }}
          >
            <Icon size={16} />
            {label}
          </button>
        ))}
        <hr />
        {(!isOfficial || !owner) &&
          (owner ? (
            <button className="text-danger" onClick={() => ask({ kind: 'server' })}>
              <Trash2 size={17} />
              {tr('Delete Server', 'Server löschen')}
            </button>
          ) : (
            <button className="text-danger" onClick={() => ask({ kind: 'leave' })}>
              <LogOut size={17} />
              {tr('Leave Server', 'Server verlassen')}
            </button>
          ))}
      </nav>
      <section className="server-settings-body" ref={bodyRef}><header className="server-settings-topbar">{(()=>{const Icon=({overview:Settings,roles:Tag,channels:Hash,templates:Copy,members:Users,bans:Ban,bots:Bot,invite:Link,audit:ScrollText,soundboard:Volume2} as Record<string,any>)[page]||Settings;return <Icon size={16}/>})()}{({discovery:'Server finden',emotes:'Server-Emotes',webhooks:'Webhooks',soundboard:'Soundboard',overview:tr('Overview','Übersicht'),roles:tr('Roles','Rollen'),channels:tr('Channels','Kanäle'),templates:tr('Channel templates','Kanalvorlagen'),members:tr('Members','Mitglieder'),bots:tr('Bots & Integrations','Bots & Integrationen'),invite:tr('Invites','Einladungen'),bans:tr('Bans','Sperren'),audit:tr('Audit Log','Audit-Protokoll')} as Record<string,string>)[page]||tr('Server settings','Servereinstellungen')}<button type="button" className="server-settings-exit" onClick={onClose} aria-label={tr('Close server settings','Servereinstellungen schließen')}><X size={20}/></button></header><div className="server-page-content">
        {confirm ? (
          <>
            <h2>
              {confirm.kind === 'server'
                ? tr('Delete Server', 'Server löschen')
                : confirm.kind === 'leave'
                ? tr('Leave Server', 'Server verlassen')
                : confirm.kind==='category'?tr('Delete category','Kategorie löschen'):tr('Delete Channel', 'Kanal löschen')}
            </h2>
            <p>
              {confirm.kind === 'server'
                ? tr(
                    'All channels and messages in this server will be permanently deleted.',
                    'Alle Kanäle und Nachrichten dieses Servers werden unwiderruflich gelöscht.'
                  )
                : confirm.kind === 'leave'
                ? tr(
                    'You will lose access to this server until invited again.',
                    'Du verlierst den Zugriff. Mit einer gültigen Einladung kannst du wieder beitreten.'
                  )
                : confirm.kind==='category'?tr('Channels keep their messages and current permissions and move outside categories.','Die Kanäle bleiben mit ihren Nachrichten und bisherigen Rechten ohne Kategorie erhalten.'):tr(
                    'All messages in this channel will be permanently deleted.',
                    'Alle Nachrichten dieses Kanals werden unwiderruflich gelöscht.'
                  )}
            </p>
            {confirm.kind !== 'leave' && <label>
              {tr('Type', 'Zur Bestätigung')} "{confirmationName}"{' '}
              {tr('to confirm', 'eingeben')}
              <input
                aria-label="Confirm name"
                value={confirmation}
                onChange={e => setConfirmation(e.target.value)}
              />
            </label>}
            <div className="settings-actions">
              <button className="secondary" onClick={() => setConfirm(null)}>
                {tr('Cancel', 'Abbrechen')}
              </button>
              <button
                className="danger"
                disabled={
                  busy || (confirm.kind !== 'leave' && confirmation !== confirmationName)
                }
                onClick={() =>
                  run(async () => {
                    if (confirm.kind === 'server') {
                      await request('/communities/' + community.id, 'DELETE', { name: confirmation });
                      onExit();
                    } else if (confirm.kind === 'leave') {
                      await request('/communities/' + community.id + '/leave', 'POST');
                      onExit();
                    } else if(confirm.kind==='category') {
                      await request('/communities/'+community.id+'/categories','DELETE',{name:confirm.category});setConfirm(null);setEditingCategory(null);await onRefresh();setSuccess(tr('Category deleted. Channels and their permissions were preserved.','Kategorie gelöscht. Kanäle und ihre Rechte bleiben erhalten.'));
                    } else {
                      await request('/channels/' + confirm.channel.id, 'DELETE', { name: confirmation });
                      setConfirm(null);
                      await onRefresh();
                    }
                  })
                }
              >
                {confirm.kind === 'leave' ? tr('Leave', 'Verlassen') : tr('Delete', 'Löschen')}
              </button>
            </div>
          </>
        ) : (
          <>
            <h2 className="server-page-title">
              {page === 'overview'
                ? tr('Server Overview', 'Serverübersicht')
                : page === 'roles'
                ? tr('Manage Roles', 'Rollen verwalten')
                : page === 'channels'
                ? tr('Channels & Permissions', 'Kanäle & Berechtigungen')
                : page === 'templates' ? tr('Channel templates','Kanalvorlagen')
                : page === 'members'
                ? `${tr('Members', 'Mitglieder')} (${members.length})`
                : page === 'bans'
                ? `${tr('Banned Users', 'Gebannte Nutzer')} (${bans.length})`
                : page === 'soundboard' ? 'Soundboard'
                : page === 'audit' ? tr('Audit Log','Audit-Protokoll')
                : tr('Invites', 'Einladungen')}
            </h2>

            {page==='overview'&&owner&&!isOfficial&&<ServerOwnership community={community} members={members} me={me} request={request} onChanged={onRefresh}/>}
            {page==='discovery'&&manage&&<DiscoverySettings community={community} request={request}/>}
            {page==='emotes'&&(owner||community.capabilities?.manageEmotes||community.capabilities?.manageServer)&&<EmoteManager communityId={community.id} request={request}/>}
            {page==='webhooks'&&<Webhooks community={community} request={request}/>}
            {page==='invite'&&canInvites&&<VanityInvite communityId={community.id} request={request}/>}
            {page === 'templates' && manage && <ChannelTemplates community={community} request={request} onRefresh={onRefresh}/>}
            {page === 'overview' && (owner || community.capabilities?.ban) && <RaidCleanup communityId={community.id} request={request} onDone={() => void onRefresh()} />}
            {page === 'overview' && owner && <section className="guild-settings">
              <div className="guild-settings-head"><div><h3>{tr('Guild Tag','Gilden-Tag')}</h3><p>{tr('Up to six letters. Shown next to member names and on profiles.','Bis zu sechs Buchstaben. Erscheint neben Mitgliedernamen und auf Profilen.')}</p></div>
                <span className="guild-tag-preview" style={{'--guild':guild.color} as React.CSSProperties}>{(()=>{const I=GUILD_ICONS[guild.icon]||Sparkles;return <I size={13}/>})()}{guild.tag||'TAG'}</span></div>
              <div className="guild-settings-row">
                <label className="guild-field">{tr('Tag','Tag')}<input aria-label="Guild tag" maxLength={6} placeholder="MALVO" value={guild.tag} onChange={e=>setGuild({...guild,tag:e.target.value.replace(/[^a-z0-9]/gi,'').toUpperCase()})}/></label>
                <div className="guild-field"><span>{tr('Symbol','Symbol')}</span><div className="guild-icon-picker" role="radiogroup">{Object.entries(GUILD_ICONS).map(([key,I])=><button type="button" key={key} role="radio" aria-checked={guild.icon===key} aria-label={key} className={guild.icon===key?'selected':''} onClick={()=>setGuild({...guild,icon:key})}><I size={16}/></button>)}</div></div>
                <div className="guild-field"><span>{tr('Color','Farbe')}</span><div className="guild-color-picker" role="radiogroup">{GUILD_COLORS.map(c=><button type="button" key={c} role="radio" aria-checked={guild.color.toLowerCase()===c} aria-label={c} className={guild.color.toLowerCase()===c?'selected':''} style={{background:c}} onClick={()=>setGuild({...guild,color:c})}/>)}<label className={'guild-color-custom'+(GUILD_COLORS.includes(guild.color.toLowerCase())?'':' selected')} title={tr('Custom color','Eigene Farbe')} style={GUILD_COLORS.includes(guild.color.toLowerCase())?undefined:{background:guild.color}}><input aria-label="Guild color" type="color" value={guild.color} onChange={e=>setGuild({...guild,color:e.target.value})}/></label></div></div>
              </div>
              <label className="guild-join-toggle"><input type="checkbox" checked={guild.joinable} onChange={e=>setGuild({...guild,joinable:e.target.checked})}/><span><b>{tr('Allow joining via tag','Beitreten über den Tag erlauben')}</b><small>{tr('When someone clicks the tag, they see a Join button. If off, others can still wear and see the tag, but cannot join through it.','Wer auf den Tag klickt, sieht einen Beitreten-Button. Wenn aus, können andere den Tag weiter sehen und tragen, aber nicht darüber beitreten.')}</small></span></label><div className="guild-settings-actions"><button type="button" className="primary" disabled={busy} onClick={async()=>{setBusy(true);try{await request('/communities/'+community.id+'/guild','PATCH',guild);await onRefresh();setSuccess(tr('Guild tag saved.','Gilden-Tag gespeichert.'));}catch(e){setError((e as Error).message);}finally{setBusy(false);}}}>{tr('Save guild tag','Gilden-Tag speichern')}</button></div>
            </section>}
            {page === 'overview' && (
              <form className="server-overview-form"
                onSubmit={e => {
                  e.preventDefault();
                  run(async () => {
                    await request('/communities/' + community.id, 'PATCH', { name, description });
                    await onRefresh();
                    setSuccess(tr('Server settings saved.', 'Server gespeichert.'));
                  });
                }}
              >
                <div className="server-overview-media"><div className="server-overview-preview">
                  {owner ? (
                    <label className="server-overview-banner is-editable" style={{backgroundImage:bannerSrc?`url(${bannerSrc})`:undefined}} title={tr('Change banner','Banner ändern')}>
                      {!bannerSrc&&<span>{tr('No banner','Kein Banner')}</span>}
                      <i className="media-edit-badge" aria-hidden="true"><Pencil size={15}/></i>
                      <input type="file" hidden accept="image/*" disabled={busy} aria-label={tr('Change banner','Banner ändern')} onChange={e=>{const f=e.target.files?.[0];if(f)setCropPending({file:f,kind:'banner'});e.target.value='';}}/>
                    </label>
                  ) : (
                    <div className="server-overview-banner" style={{backgroundImage:bannerSrc?`url(${bannerSrc})`:undefined}}>{!bannerSrc&&<span>{tr('No banner','Kein Banner')}</span>}</div>
                  )}
                  {owner ? (
                    <label className="server-overview-icon is-editable" title={tr('Change server icon','Serverbild ändern')}>
                      {iconSrc?<img src={iconSrc} alt=""/>:community.name.slice(0,1)}
                      <i className="media-edit-badge" aria-hidden="true"><Pencil size={18}/></i>
                      <input type="file" hidden accept="image/*" disabled={busy} aria-label={tr('Change server icon','Serverbild ändern')} onChange={e=>{const f=e.target.files?.[0];if(f)setCropPending({file:f,kind:'icon'});e.target.value='';}}/>
                    </label>
                  ) : (
                    <div className="server-overview-icon">{iconSrc?<img src={iconSrc} alt=""/>:community.name.slice(0,1)}</div>
                  )}
                  <h3>{name}</h3><p>{description||tr('No description yet.','Noch keine Beschreibung.')}</p>
                  {owner&&community.banner&&<button type="button" className="server-overview-remove" disabled={busy} onClick={()=>run(async()=>{await request('/communities/'+community.id+'/banner','POST',{uploadId:null});await onRefresh();setSuccess(tr('Banner removed.','Banner entfernt.'));})}>{tr('Remove banner','Banner entfernen')}</button>}
                  {owner&&<small className="server-overview-hint">{tr('Hover the banner or icon and click to change it. PNG, JPG, WebP or animated GIF.','Banner oder Icon anklicken, um es zu ändern. PNG, JPG, WebP oder animiertes GIF.')}</small>}
                </div>
                </div>
                <label>
                  {tr('Server Name', 'Servername')}
                  <input
                    value={name}
                    onChange={e => setName(e.target.value)}
                    minLength={2}
                    maxLength={48}
                    required
                    disabled={!owner}
                  />
                </label>
                <label>
                  {tr('Server Description / Banner Tagline', 'Server-Beschreibung / Slogan (im Banner sichtbar)')}
                  <textarea
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    maxLength={140}
                    placeholder={tr('Tell people about your community.','Beschreibe deine Community.')}
                    disabled={!owner}
                  />
                </label>
                <p>
                  {members.length} {tr('Members', 'Mitglieder')} · {community.channels.length}{' '}
                  {tr('Channels', 'Kanäle')}
                </p>
                {owner && (
                  <button
                    className="primary"
                    disabled={busy || (name === community.name && description === (community.description || ''))}
                  >
                    {tr('Save Changes', 'Änderungen speichern')}
                  </button>
                )}
              </form>
            )}
            

            {page==='roles'&&<ServerRoleManager request={request} id={community.id} manage={canEditRoles} onRefresh={async()=>{await loadRoles();await onRefresh()}}/>}

            {page === 'channels' && (
              <>
                {manage && (
                  <button className="secondary" style={{ marginBottom: '16px' }} onClick={onCreateChannel}>
                    <Plus size={16} />
                    {tr('Create Channel', 'Kanal erstellen')}
                  </button>
                )}
                {canEditChannels&&<form className="channel-category-tools" onSubmit={e=>{e.preventDefault();void run(async()=>{await request('/communities/'+community.id+'/categories','POST',{name:newCategory});setNewCategory('');await onRefresh();setSuccess(tr('Category created.','Kategorie erstellt.'))})}}><label>{tr('New category','Neue Kategorie')}<input aria-label={tr('New category','Neue Kategorie')} required maxLength={40} value={newCategory} onChange={e=>setNewCategory(e.target.value)}/></label><button className="secondary" disabled={busy||!newCategory.trim()}><Plus size={15}/>{tr('Create category','Kategorie erstellen')}</button></form>}
                {categoryNames.map(cat => {
                  const inCat = community.channels.filter((c: any) => (c.category || '') === cat);
                  return <section key={cat} className="channel-category-group">
                    <header className="channel-category-head" id={'category-editor-' + cat}>
                      <b>{cat||tr('No category','Ohne Kategorie')}</b><small>{inCat.length} {tr(inCat.length === 1 ? 'channel' : 'channels', inCat.length === 1 ? 'Kanal' : 'Kanäle')}</small>
                      {canEditChannels&&!!cat&&<><button type="button" className="secondary" onClick={() => setEditingCategory(editingCategory === cat ? null : cat)}><Settings size={14} />{tr('Edit category', 'Kategorie bearbeiten')}</button><button type="button" className="danger" aria-label={tr('Delete category ','Kategorie löschen: ')+cat} onClick={()=>ask({kind:'category',category:cat})}><Trash2 size={15}/>{tr('Delete','Löschen')}</button></>}
                    </header>
                    {editingCategory === cat && <CategoryEditor key={cat} members={members} roles={roles} initial={community.categoryPermissions?.[cat]} name={cat} count={inCat.length} busy={busy} tr={tr} onCancel={() => setEditingCategory(null)} onSave={(v: any) => run(async () => { await request('/communities/' + community.id + '/categories', 'PATCH', { from: cat, ...v }); await onRefresh(); setEditingCategory(null); setSuccess(tr('Category saved.', 'Kategorie gespeichert.')); })} />}
                    {inCat.map((c: any) => (
                  <ChannelEditor
                    key={c.id}
                    channel={c} request={request} communityId={community.id}
                    roles={roles} members={members} categories={categoryNames.filter(Boolean)} categoryPermissions={community.categoryPermissions||{}}
                    onDuplicate={()=>void run(async()=>{await request('/communities/'+community.id+'/channels','POST',{name:(c.name.slice(0,30)+'-copy'),kind:c.kind,topic:c.topic||'',icon:c.icon||'',category:c.category||'',readOnly:!!c.readOnly,permissions:c.permissions||{}});await onRefresh();setSuccess(tr('Channel duplicated without messages.','Kanal ohne Nachrichten dupliziert.'));})}
                    open={openChannels.includes(c.id)}
                    onToggle={() => setOpenChannels(o => o.includes(c.id) ? o.filter(x => x !== c.id) : [...o, c.id])}
                    manage={canEditChannels}
                    busy={busy}
                    tr={tr}
                    onSave={(v: any) =>
                      run(async () => {
                        await request('/channels/' + c.id, 'PATCH', v);
                        await onRefresh();
                        setSuccess(tr('Channel saved.', 'Kanal gespeichert.'));
                      })
                    }
                    onDelete={() => ask({ kind: 'channel', channel: c })}
                  />
                    ))}
                  </section>;
                })}
              </>
            )}

            {page === 'members' && (
              <div className="clean-members-list"><label className="server-member-search"><Users size={16}/><input aria-label={tr('Search members','Mitglieder suchen')} placeholder={tr('Search members','Mitglieder suchen')} value={memberQuery} onChange={e=>setMemberQuery(e.target.value)}/></label><div className="member-table-head"><span>{tr('Member','Mitglied')}</span><span>{tr('Roles & actions','Rollen & Aktionen')}</span></div>
                {members.filter(p=>(p.displayName+' '+p.username).toLowerCase().includes(memberQuery.toLowerCase())).map(p => {
                  const avatarSrc = defaultAvatarSrc(p);
                  const isTargetOwner =
                    p.role === 'owner' || (isOfficial && p.username?.toLowerCase() === 'malvo');
                  const memberRoles: any[] = p.customRoles || [];
                  return (
                    <div className="clean-member-card" key={p.id}>
                      <div className="clean-member-identity">
                        <span
                          className="clean-member-avatar"
                          style={{ background: p.color || '#2b2b36' }}
                        >
                          {avatarSrc ? (
                            <img src={avatarSrc} alt={p.displayName} />
                          ) : (
                            p.displayName.slice(0, 2).toUpperCase()
                          )}
                        </span>
                        <div className="clean-member-names">
                          <div className="clean-member-title">
                            <b style={{ color: p.roleColor || '#ffffff' }}>{p.displayName}</b>
                            {isTargetOwner && <span className="role-pill owner-pill">Official</span>}
                            {memberRoles
                              .filter(
                                (mr: any) =>
                                  !isTargetOwner || !['owner', 'official'].includes(String(mr.name || '').toLowerCase())
                              )
                              .map((mr: any) => (
                                <span
                                  key={mr.id}
                                  className="role-pill"
                                  style={{
                                    background: `${mr.color}22`,
                                    color: mr.color
                                  }}
                                  role={canEditRoles?'button':undefined} tabIndex={canEditRoles?0:undefined} aria-label={canEditRoles?tr('Remove role ','Rolle entfernen: ')+mr.name:undefined}
                                  onKeyDown={event=>{if(canEditRoles&&(event.key==='Enter'||event.key===' ')){event.preventDefault();event.currentTarget.click()}}}
                                  title={canEditRoles ? tr('Click to remove role', 'Klicken zum Entfernen') : mr.name}
                                  onClick={() => {
                                    if (!canEditRoles) return;
                                    run(async () => {
                                      await request(
                                        '/communities/' + community.id + '/members/' + p.id + '/roles',
                                        'POST',
                                        { roleId: mr.id, assigned: false }
                                      );
                                      await onRefresh();
                                    });
                                  }}
                                >
                                  <i style={{ background: mr.color }} />
                                  {mr.name}
                                  <RoleIcon icon={mr.icon}/>
                                  {canEditRoles && <span className="role-pill-x">×</span>}
                                </span>
                              ))}
                          </div>
                          <small>@{p.username}</small>
                        </div>
                      </div>

                      {(manage||canEditRoles) && (
                        <div className="clean-member-actions">
                          {canEditRoles && roles.length > 0 && (
                            <div style={{ minWidth: '170px' }}>
                              <CustomSelect
                                value=""
                                placeholder={tr('+ Assign Role', '+ Rolle vergeben')}
                                onChange={rid => {
                                  if (!rid) return;
                                  run(async () => {
                                    await request(
                                      '/communities/' + community.id + '/members/' + p.id + '/roles',
                                      'POST',
                                      { roleId: rid, assigned: true }
                                    );
                                    await onRefresh();
                                    setSuccess(tr('Role updated.', 'Rolle aktualisiert.'));
                                  });
                                }}
                                options={roles.map(r => ({
                                  value: r.id,
                                  label: (memberRoles.some(x => x.id === r.id) ? '✓ ' : '') + r.name,
                                  dotColor: r.color
                                }))}
                              />
                            </div>
                          )}
                          {manage&&!isTargetOwner && p.id !== me.id && (
                            <>
                              <button
                                type="button"
                                className="member-kick-btn"
                                title={tr('Kick from server', 'Vom Server kicken')}
                                disabled={busy}
                                onClick={() => onKick(p)}
                              >
                                <UserX size={15} /> Kick
                              </button>
                              <button
                                type="button"
                                className="member-ban-btn"
                                title={tr('Ban from server', 'Vom Server bannen')}
                                disabled={busy}
                                onClick={() =>
                                  run(async () => {
                                    await request('/communities/' + community.id + '/bans', 'POST', {
                                      userId: p.id,
                                      reason: 'Banned by server administration'
                                    });
                                    await loadBans();
                                    await onRefresh();
                                    setSuccess(p.displayName + tr(' was banned.', ' wurde gebannt.'));
                                  })
                                }
                              >
                                <Ban size={15} /> Ban
                              </button>
                            </>
                          )}
                        </div>
                      )}
                      {p.id!==me.id&&<MemberControls person={p} community={community} request={request} onRefresh={onRefresh}/>}
                    </div>
                  );
                })}
              </div>
            )}

            {page === 'bots' && <ServerApps request={request} communityId={community.id} manage={owner||!!community.capabilities?.manageInvites||manage} onRefresh={onRefresh}/>}

            {page === 'bans' && (
              <div className="clean-members-list">{manage&&<form className="server-ban-form" onSubmit={e=>{e.preventDefault();void run(async()=>{const target=members.find(p=>p.username.toLowerCase()===banName.toLowerCase()||p.id===banName);if(!target)throw Error(tr('Enter a current member username or ID.','Gib den Nutzernamen oder die ID eines aktuellen Mitglieds ein.'));await request('/communities/'+community.id+'/bans','POST',{userId:target.id,reason:banReason});setBanName('');setBanReason('');await loadBans();await onRefresh();})}}><input aria-label={tr('Username or user ID','Nutzername oder Nutzer-ID')} placeholder={tr('Username or user ID','Nutzername oder Nutzer-ID')} required value={banName} onChange={e=>setBanName(e.target.value)}/><input aria-label={tr('Reason','Begründung')} placeholder={tr('Reason (optional)','Begründung (optional)')} maxLength={200} value={banReason} onChange={e=>setBanReason(e.target.value)}/><button className="danger" disabled={busy||!banName.trim()}><Ban size={16}/>{tr('Ban','Sperren')}</button></form>}
                {bans.length === 0 ? (
                  <p style={{ color: '#8a8e9c' }}>
                    {tr('No users are currently banned from this server.', 'Aktuell sind keine Nutzer auf diesem Server gebannt.')}
                  </p>
                ) : (
                  bans.map(b => (
                    <div className="clean-member-card" key={b.userId}>
                      <div className="clean-member-identity">
                        <span className="clean-member-avatar" style={{ background: '#2b2b36' }}>
                          {(b.person?.displayName || 'U').slice(0, 2).toUpperCase()}
                        </span>
                        <div className="clean-member-names">
                          <b>{b.person?.displayName || 'User'}</b>
                          <small>@{b.person?.username || b.userId}</small>
                        </div>
                      </div>
                      {manage && (
                        <button
                          type="button"
                          className="secondary"
                          disabled={busy}
                          onClick={() =>
                            run(async () => {
                              await request('/communities/' + community.id + '/bans/' + b.userId, 'DELETE');
                              await loadBans();
                              setSuccess(tr('User unbanned.', 'Bann aufgehoben.'));
                            })
                          }
                        >
                          {tr('Unban', 'Entbannen')}
                        </button>
                      )}
                    </div>
                  ))
                )}
              </div>
            )}

            {page==='invite'&&(owner||community.capabilities?.manageServer)&&<InviteLinkGuard request={request} community={community} onRefresh={onRefresh}/>}
            {page==='invite'&&<CommunityInvites request={request} id={community.id}/>}
            {page==='audit'&&<CommunityAudit request={request} id={community.id}/>}
            {page==='soundboard'&&<SoundboardSettings request={request} communityId={community.id}/>}
          </>
        )}
        {success && (
          <p className="inline-success" role="status">
            {success}
          </p>
        )}
        {error && (
          <p className="form-error" role="alert">
            {error}
          </p>
        )}
      </div>
      </section>
    </div>
  );
}

// Category settings: new name plus permissions that are copied onto every channel in it (unchanged values stay as they are).
function CategoryEditor({ name, count, busy, tr, onSave, onCancel, roles, initial, members }: any) {
  const [to, setTo] = useState(name);
  const [applyToAll,setApplyToAll]=useState(true);
  const [perms, setPerms] = useState<Record<string, any>>(initial||{});
  const toggle = (key: string) => setPerms(p => ({ ...p, [key]: p[key] === undefined ? true : p[key] ? false : undefined }));
  const state = (key: string) => perms[key] === undefined ? tr('unchanged', 'unverändert') : perms[key] ? tr('allowed', 'erlaubt') : tr('denied', 'verboten');
  const rows: [string, string, string][] = [['sendMessages', 'Send messages', 'Nachrichten senden'], ['attachFiles', 'Attach files', 'Dateien senden'], ['addReactions', 'Add reactions', 'Reaktionen'], ['connectVoice', 'Connect & speak (voice)', 'Beitreten & Sprechen (Sprache)']];
  return <form className="category-editor" onSubmit={e => { e.preventDefault(); onSave({ to: to.trim() || name, permissions: perms,replacePermissions:true,applyToAll }); }}>
    <label>{tr('Category name', 'Kategoriename')}<input value={to} maxLength={40} onChange={e => setTo(e.target.value)} /></label>
    <div className="category-perms">
      <span className="category-perms-title">{tr('Permissions for all', 'Rechte für alle')} {count} {tr('channels in this category', 'Kanäle dieser Kategorie')}</span>
      <div className="category-perm-row"><span>{tr('Who can view', 'Wer darf sehen')}</span>
        <div className="category-segment">{([['', tr('unchanged', 'unverändert')], ['all', '@everyone'], ['roles', tr('Roles only', 'Nur Rollen')]] as [string, string][]).map(([v, l]) => <button type="button" key={v} className={(perms.viewChannel || '') === v ? 'selected' : ''} onClick={() => setPerms(p => { const n = { ...p }; if (v) n.viewChannel = v; else delete n.viewChannel; return n; })}>{l}</button>)}</div></div>
      {rows.map(([key, en, de]) => <button type="button" key={key} className={'category-perm-row is-toggle state-' + (perms[key] === undefined ? 'keep' : perms[key] ? 'on' : 'off')} onClick={() => toggle(key)}><span>{tr(en, de)}</span><em>{state(key)}</em></button>)}
    </div>
    <ChannelRolePermissions roles={roles} members={members} memberValue={perms.memberOverrides} onMemberChange={memberOverrides=>setPerms(p=>({...p,memberOverrides}))} value={perms.roleOverrides} disabled={busy} onChange={roleOverrides=>setPerms(p=>({...p,roleOverrides}))}/><label className="channel-sync-control"><input type="checkbox" checked={applyToAll} onChange={e=>setApplyToAll(e.target.checked)} disabled={busy}/>{tr("Link all category channels to these permissions. Otherwise only already linked channels update.","Alle Kanäle dieser Kategorie mit diesen Rechten verknüpfen. Andernfalls werden nur bereits verknüpfte Kanäle aktualisiert.")}</label>
    <div className="settings-actions"><button className="primary" disabled={busy}><Check size={15} />{tr('Apply to category', 'Auf Kategorie anwenden')}</button><button type="button" className="secondary" onClick={onCancel}>{tr('Cancel', 'Abbrechen')}</button></div>
  </form>;
}

function ChannelEditor({ channel, request, communityId, manage, busy, tr, onSave, onDelete, onDuplicate, open = true, onToggle, roles, members, categories, categoryPermissions }: any) {
  const isDefaultReadonly = ['regeln', 'rules', 'ankündigungen', 'announcements', 'willkommen', 'welcome'].includes(
    channel.name.toLowerCase()
  );
  const existingPerms = channel.permissions || {};

  const [icon,setIcon]=useState(channel.icon||'');
  const [name, setName] = useState(channel.name);
  const [topic, setTopic] = useState(channel.topic || '');
  const [category, setCategory] = useState(
    channel.category || ''
  );
  const [viewChannel, setViewChannel] = useState<string>(existingPerms.viewChannel || 'all');
  const [sendMessages, setSendMessages] = useState<boolean>(
    existingPerms.sendMessages !== undefined
      ? !!existingPerms.sendMessages
      : !(channel.readOnly === 1 || isDefaultReadonly)
  );
  const [attachFiles, setAttachFiles] = useState<boolean>(
    existingPerms.attachFiles !== undefined ? !!existingPerms.attachFiles : true
  );
  const [addReactions, setAddReactions] = useState<boolean>(
    existingPerms.addReactions !== undefined ? !!existingPerms.addReactions : true
  );
  const [connectVoice, setConnectVoice] = useState<boolean>(
    existingPerms.connectVoice !== undefined ? !!existingPerms.connectVoice : true
  );

  const [roleOverrides,setRoleOverrides]=useState<RoleOverrides>(existingPerms.roleOverrides||{});
  const [memberOverrides,setMemberOverrides]=useState<RoleOverrides>(existingPerms.memberOverrides||{}),[syncPermissions,setSyncPermissions]=useState(!!channel.permissionsSynced),[slowmodeSeconds,setSlowmodeSeconds]=useState(channel.slowmodeSeconds||0),[userLimit,setUserLimit]=useState(channel.userLimit||12);
  const useCategory=(name:string)=>{const perms=categoryPermissions[name]||{};setViewChannel(perms.viewChannel||'all');setSendMessages(perms.sendMessages!==false);setAttachFiles(perms.attachFiles!==false);setAddReactions(perms.addReactions!==false);setConnectVoice(perms.connectVoice!==false);setRoleOverrides(perms.roleOverrides||{});setMemberOverrides(perms.memberOverrides||{})};
  const readOnly = !sendMessages;

  return (
    <form
      className={'channel-editor' + (open ? ' is-open' : ' is-collapsed')}
      id={'channel-editor-' + channel.id}
      onSubmit={e => {
        e.preventDefault();
        onSave({
          name,icon,
          topic,
          category,
          syncPermissions,slowmodeSeconds,readOnly,userLimit,
          permissions: {
            viewChannel,
            sendMessages,
            attachFiles,
            addReactions,
            connectVoice,
            memberOverrides,roleOverrides
          }
        });
      }}
    >
      <button type="button" className="channel-editor-toggle" aria-expanded={open} onClick={onToggle}>
        {icon?<ChannelIcon value={icon}/>:channel.kind === 'voice' ? <Volume2 size={15} /> : <Hash size={15} />}
        <b>{channel.name}</b>
        <small>{viewChannel === 'roles' ? tr('Private', 'Privat') : tr('Public', 'Öffentlich')}{channel.kind === 'text' && !sendMessages ? ' · ' + tr('read-only', 'nur lesen') : ''}</small>
        <ChevronDown size={16} className="channel-editor-chevron" />
      </button>
      {open && <div className="channel-editor-body"><ChannelIconPicker value={icon} onChange={setIcon} disabled={!manage||busy} request={request} communityId={communityId}/>
      <div className="channel-editor-top-grid">
        <label>
          {channel.kind === 'voice' ? (
            <>
              <Volume2 size={14} style={{ verticalAlign: 'middle', marginRight: '5px' }} />
              {tr('Voice Channel Name', 'Sprachraum-Name')}
            </>
          ) : (
            <>
              <Hash size={14} style={{ verticalAlign: 'middle', marginRight: '5px' }} />
              {tr('Text Channel Name', 'Textkanal-Name')}
            </>
          )}
          <input
            aria-label={'Channel name ' + channel.name}
            value={name}
            onChange={e => setName(e.target.value)}
            required
            maxLength={40}
            disabled={!manage}
          />
        </label>

        <label>
          {tr('Category Section', 'Kategorie')}
          <select aria-label={tr('Channel category','Kategorie des Kanals')} value={category} disabled={!manage||busy} onChange={e=>{setCategory(e.target.value);if(syncPermissions&&e.target.value)useCategory(e.target.value);if(!e.target.value)setSyncPermissions(false)}}><option value="">{tr('No category','Ohne Kategorie')}</option>{categories.map((name:string)=><option key={name} value={name}>{name}</option>)}</select>
        </label>
      </div>

      <label>
        {tr('Channel Topic / Description', 'Thema / Kanalbeschreibung')}
        <input
          aria-label={'Topic ' + channel.name}
          placeholder={tr('Channel topic / description', 'Thema / Kanalbeschreibung')}
          value={topic}
          onChange={e => setTopic(e.target.value)}
          maxLength={140}
          disabled={!manage}
        />
      </label>

      <div className="channel-sync-control"><label><input type="checkbox" checked={syncPermissions} disabled={!manage||busy||!category} onChange={e=>{setSyncPermissions(e.target.checked);if(e.target.checked)useCategory(category)}}/>{tr('Synchronize permissions with category','Rechte mit der Kategorie synchronisieren')}</label><p>{syncPermissions?tr('Category changes automatically apply to this channel.','Änderungen an der Kategorie gelten automatisch auch für diesen Kanal.'):tr('This channel uses its own role and member permissions.','Dieser Kanal verwendet eigene Rollen- und Mitgliedsrechte.')}</p></div>
      {channel.kind==='voice'&&<label>{tr('Participant limit','Teilnehmerlimit')}<input type="number" min={1} max={12} disabled={!manage||busy} value={userLimit} onChange={e=>setUserLimit(Number(e.target.value))}/><small>{tr('Between 1 and 12 people. Existing participants stay when the limit is reduced.','Zwischen 1 und 12 Personen. Beim Verringern bleiben vorhandene Teilnehmer verbunden.')}</small></label>}
      {channel.kind==='text'&&<label>{tr('Slowmode','Slowmode')}<select aria-label="Slowmode" disabled={!manage||busy} value={slowmodeSeconds} onChange={e=>setSlowmodeSeconds(Number(e.target.value))}>{[0,5,10,15,30,60,120,300,600,900,1800,3600,21600].map(value=><option value={value} key={value}>{value?value<60?value+' s':value<3600?(value/60)+' min':(value/3600)+' h':tr('Off','Aus')}</option>)}</select><small>{tr('Members with Manage Messages bypass slowmode.','Mitglieder mit „Nachrichten verwalten“ umgehen den Slowmode.')}</small></label>}
      <fieldset className="channel-custom-permissions" disabled={!manage||busy||syncPermissions}>
      <div className="channel-permissions-box">
        <div className="channel-perm-header">
          <Shield size={14} />
          <span>{tr('Channel Permissions', 'Kanal-Berechtigungen')}</span>
        </div>

        <div className="channel-perm-access-row">
          <span>
            <Eye size={14} style={{ verticalAlign: 'middle', marginRight: '6px' }} />
            {tr('Who can view this channel?', 'Wer darf diesen Kanal sehen?')}
          </span>
          <div style={{ minWidth: '220px' }}>
            <CustomSelect
              value={viewChannel}
              disabled={!manage}
              onChange={setViewChannel}
              options={[
                { value: 'all', label: tr('@everyone (Public)', '@everyone (Öffentlich)'), dotColor: '#22c55e' },
                {
                  value: 'roles',
                  label: tr('Private (Roles & Admins only)', 'Privat (Nur Rollen & Admins)'),
                  dotColor: '#ef5252'
                }
              ]}
            />
          </div>
        </div>

        {channel.kind === 'text' ? (
          <div className="channel-perms-toggles-grid">
            <button
              type="button"
              className={'animated-perm-toggle ' + (sendMessages ? 'is-checked' : '')}
              disabled={!manage}
              onClick={() => setSendMessages(!sendMessages)}
            >
              <span className="animated-perm-box">
                <Check size={13} strokeWidth={3} />
              </span>
              <span className="animated-perm-label">
                {tr('Send Messages (@everyone can post)', 'Nachrichten senden (@everyone darf schreiben)')}
              </span>
            </button>

            <button
              type="button"
              className={'animated-perm-toggle ' + (attachFiles ? 'is-checked' : '')}
              disabled={!manage}
              onClick={() => setAttachFiles(!attachFiles)}
            >
              <span className="animated-perm-box">
                <Check size={13} strokeWidth={3} />
              </span>
              <span className="animated-perm-label">
                {tr('Attach Files, Images & Videos', 'Dateien, Bilder & Videos senden')}
              </span>
            </button>

            <button
              type="button"
              className={'animated-perm-toggle ' + (addReactions ? 'is-checked' : '')}
              disabled={!manage}
              onClick={() => setAddReactions(!addReactions)}
            >
              <span className="animated-perm-box">
                <Check size={13} strokeWidth={3} />
              </span>
              <span className="animated-perm-label">
                {tr('Add Reactions & GIFs', 'Reaktionen & GIFs hinzufügen')}
              </span>
            </button>
          </div>
        ) : (
          <div className="channel-perms-toggles-grid">
            <button
              type="button"
              className={'animated-perm-toggle ' + (connectVoice ? 'is-checked' : '')}
              disabled={!manage}
              onClick={() => setConnectVoice(!connectVoice)}
            >
              <span className="animated-perm-box">
                <Check size={13} strokeWidth={3} />
              </span>
              <span className="animated-perm-label">
                {tr('Connect & Speak in Voice Channel', 'Beitreten & Sprechen im Sprachraum')}
              </span>
            </button>
          </div>
        )}
      </div>

      <ChannelRolePermissions roles={roles} members={members} memberValue={memberOverrides} onMemberChange={setMemberOverrides} value={roleOverrides} onChange={setRoleOverrides} disabled={!manage||busy||syncPermissions}/></fieldset>
      {manage && (
        <div className="settings-actions">
          <button className="primary" disabled={busy}>
            <Check size={15} /> {tr('Save Channel', 'Kanal speichern')}
          </button>
          <button type="button" className="secondary" disabled={busy} onClick={onDuplicate}><Copy size={15}/>{tr('Duplicate channel','Kanal duplizieren')}</button>
          <button type="button" className="text-danger" disabled={busy} onClick={onDelete}>
            <Trash2 size={15} />
            {tr('Delete', 'Löschen')}
          </button>
        </div>
      )}
      </div>}
    </form>
  );
}
